import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Page,
    CalloutCard,
    Frame,
    Layout,
    List,
    Button,
    Card,
    Icon,
    Heading,
    Checkbox,
    Spinner,
    Toast,
} from "@shopify/polaris";
import Main_Page from "../Main_Page";
import Footer from "../footer";

import * as authService from "../../services/authService";
import Loader from "../../Loader";
import axios from "axios";
export const SHOP_PLAN = "SHOP_PLAN";
export default function Index() {
    const dispatch = useDispatch();

    const [loadingFlagAdvance, setLoadingFlagAdvance] = useState(false);
    const [loadingFlag, setLoadingFlag] = useState(false);
    const [apiCallFlag, setApiCallFlag] = useState(false);
    const [errorFlag, setErrorFlag] = useState(false);
    const [getEnv, setGetEnv] = useState("");
    const [plan_name, setPlanName] = useState("");
    const shop_plan = useSelector((state) => state.allReducer.shop_plan);

    useEffect(() => {
        setLoadingFlag(true);

        authService
            .getEnv()
            .then((res) => {
                if (res && res.data && res.data.data && res.data.data.data) {
                    setGetEnv(res.data.data.data);
                    setPlanName(res.data.data.plan_name);
                }
            })
            .catch((error) => {
                setLoadingFlag(false);
                setErrorFlag(true);
                console.log("error", error);
            });
    }, []);

    useEffect(() => {
        setLoadingFlag(true);

        authService
            .planDetail()
            .then((response) => {
                dispatch({
                    type: SHOP_PLAN,
                    data: { ...response, loading: false },
                });
                setLoadingFlag(false);
            })
            .catch((error) => {
                dispatch({
                    type: SHOP_PLAN,
                    data: { loading: true },
                });
                setLoadingFlag(false);
                setErrorFlag(true);
                console.log("error", error);
            });
    }, [apiCallFlag]);

    const buyNowHandle = () => {
        setLoadingFlagAdvance(true);
        authService
            .premiumPlan()
            .then((response) => {
                if (response && response.status === 200) {
                    window.parent.location.replace(
                        response.data.data.redirect_url
                    );
                }
            })
            .catch((error) => {
                setLoadingFlagAdvance(false);

                console.log(error);
            });
    };
    const buyBasic = async () => {
        await setLoadingFlag(true);
        authService
            .makeUserBasic()
            .then(async (res) => {
                setApiCallFlag(true);
            })
            .catch(async (err) => {
                setLoadingFlag(false);
            });
    };

    return (
        <>
            <Main_Page />

            {loadingFlag ? (
                <div className="card-spinner">
                    <Spinner />
                </div>
            ) : (
                <Page
                    breadcrumbs={[{ content: "Dashboard", url: "/" }]}
                    title="Account"
                >
                    <Frame>
                        {errorFlag && <Toast error content="Server Error" />}
                        {!(shop_plan && !shop_plan.loading
                            ? loadingFlag
                            : shop_plan && shop_plan.loading) ? (
                            shop_plan &&
                            shop_plan.plan &&
                            shop_plan.plan === "basic" && (
                                <CalloutCard
                                    title="Upgrade to Plus Plan"
                                    illustration="https://cdn.shopify.com/s/assets/admin/checkout/settings-customizecart-705f57c725ac05be5a34ec20c05b94298cb8afd10aac7bd9c7ad02030f48cfa0.svg"
                                    primaryAction={{
                                        content: "Upgrade",
                                        onAction: () => {
                                            buyNowHandle();
                                        },
                                    }}
                                >
                                    <p>
                                        Update your activation message with a
                                        custom heading, text, image and password
                                        form style.
                                    </p>
                                </CalloutCard>
                            )
                        ) : (
                            <Card sectioned>
                                <div className="card-spinner">
                                    <Spinner size="small" />
                                </div>
                            </Card>
                        )}

                        <br />
                        <br />
                        <div>
                            <Layout>
                                <Layout.Section oneHalf>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginRight: "35px",
                                        }}
                                    >
                                        <Card sectioned subdued>
                                            <div
                                                style={{ textAlign: "center" }}
                                            >
                                                <Heading>FREE PLAN</Heading>
                                                <Heading>$ 0</Heading>
                                            </div>
                                            <br />

                                            <List>
                                                {" "}
                                                <Checkbox
                                                    label="Post Purchase Account Activation"
                                                    checked={true}
                                                />
                                            </List>
                                            <List>
                                                <Checkbox
                                                    label="Unlimited Activation"
                                                    checked={true}
                                                />
                                            </List>
                                            <List>
                                                <Checkbox
                                                    label="Default Message only"
                                                    checked={true}
                                                />
                                            </List>
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            <div
                                                style={{ textAlign: "center" }}
                                            >
                                                <span style={{ color: "blue" }}>
                                                    {shop_plan &&
                                                        shop_plan.plan &&
                                                        shop_plan.plan ===
                                                        "basic" ? (
                                                        <Button
                                                            outline
                                                            monochrome
                                                            disabled
                                                        >
                                                            <div
                                                                style={{
                                                                    display:
                                                                        "flex",
                                                                }}
                                                            >
                                                                Active
                                                            </div>
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            outline
                                                            monochrome={
                                                                !(
                                                                    shop_plan &&
                                                                    !shop_plan.loading
                                                                )
                                                                    ? loadingFlag
                                                                    : shop_plan &&
                                                                    shop_plan.loading
                                                            }
                                                            onClick={buyBasic}
                                                            loading={
                                                                shop_plan &&
                                                                    !shop_plan.loading
                                                                    ? loadingFlag
                                                                    : shop_plan &&
                                                                    shop_plan.loading
                                                            }
                                                        >
                                                            Basic Plan
                                                        </Button>
                                                    )}
                                                </span>
                                            </div>
                                        </Card>
                                    </div>
                                </Layout.Section>
                                <Layout.Section oneHalf>
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-start",
                                            marginLeft: "35px",
                                        }}
                                    >
                                        <Card sectioned subdued>
                                            <div
                                                style={{ textAlign: "center" }}
                                            >

                                                <Heading>{plan_name == "shopify_plus" ? "SHOPIFY PLUS PLAN" : "SUPERDUPER PLAN"}</Heading>
                                                <Heading>
                                                    <span>$</span>
                                                    <span>{getEnv}</span>
                                                    <span>/month</span>
                                                </Heading>
                                            </div>
                                            <br />
                                            <List>
                                                {" "}
                                                <Checkbox
                                                    label="Post Purchase Account Activation"
                                                    checked={true}
                                                />
                                            </List>
                                            <List>
                                                <Checkbox
                                                    label="Unlimited Activation"
                                                    checked={true}
                                                />
                                            </List>
                                            <List>
                                                <Checkbox
                                                    label="Custom Activation Message"
                                                    checked={true}
                                                />
                                            </List>
                                            <List>
                                                <Checkbox
                                                    label="Priority Support"
                                                    checked={true}
                                                />
                                            </List>
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                            <div
                                                style={{ textAlign: "center" }}
                                            >
                                                <span style={{ color: "blue" }}>
                                                    {shop_plan &&
                                                        shop_plan.plan &&
                                                        shop_plan.plan ===
                                                        "advance" ? (
                                                        <Button
                                                            outline
                                                            monochrome
                                                            disabled
                                                        >
                                                            <div
                                                                style={{
                                                                    display:
                                                                        "flex",
                                                                }}
                                                            >
                                                                {/* <Icon
													source={TickSmallMinor}
													style={{ color: "blue" }}
												/> */}
                                                                Active
                                                            </div>
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            primary
                                                            monochrome={
                                                                !(
                                                                    shop_plan &&
                                                                    !shop_plan.loading
                                                                )
                                                                    ? loadingFlagAdvance
                                                                    : shop_plan &&
                                                                    shop_plan.loading
                                                            }
                                                            onClick={
                                                                buyNowHandle
                                                            }
                                                            loading={
                                                                shop_plan &&
                                                                    !shop_plan.loading
                                                                    ? loadingFlagAdvance
                                                                    : shop_plan &&
                                                                    shop_plan.loading
                                                            }
                                                        >
                                                            Upgrade
                                                        </Button>
                                                    )}
                                                </span>
                                            </div>
                                        </Card>
                                    </div>
                                </Layout.Section>
                            </Layout>
                        </div>
                    </Frame>
                    <Footer />
                </Page>
            )}
        </>
    );
}
